import React from 'react';
import './Header.css'

const Header = () => {
    return (
        <div className='header-name'>
            <h1>Your Fav Phones</h1>
            <h2>Choose Your cars!</h2>
        </div>
    );
};

export default Header;